import React from "react";
import Pagination from "../../components/Pagination";
import { CGE } from "../CGE";
import './headerTable.scss';

function HeaderTable({ props }) {
    return (
        <div className="content-download d-flex justify-content-between align-items-center">
            {(props?.title || props?.description) && <div className="table-header">
                <CGE.Heading size="3" className="text-title" text={props?.title && props?.title} />
                <CGE.Text size="2" className="text-description" text={props?.description && props?.description} />
            </div>}
            {(props?.showPagination || props?.excelBtn) &&
                <div className="table-pagination-content d-inline-flex align-items-center resp-column">

                    {props?.showPagination && <Pagination items={props?.auxArray}
                        onChangePage={props?.setActivePage}
                        qtdRowPage={props?.qtdRowPage}
                        setRowPage={props?.setRowPage}
                        pageSize={props?.rowPage}
                        currentPg={props?.activePage}
                    />}

                    {props?.excelBtn && <CGE.ButtonExcel props={props} />}
                </div>
            }

        </div>
    );
}

export default HeaderTable;
